<template>
  <div class="bg-navy d-block d-md-none">
    <b-row class="no-gutters">
      <b-col class="text-center">
        <b-button type="button" variant="link" class="color-white float-left py-3" to="/home">
          <feather type="arrow-left"></feather>
        </b-button>
        <span class="d-inline-block h-100 title-w-40">
          <span class="d-table h-100">
            <span class="d-table-cell align-middle">
              <strong class="color-white">Payment authorizations</strong>
            </span>
          </span>
        </span>
        <b-dropdown no-caret right variant="link" class="float-right" menu-class="box-shadow border-0 rounded-sm overflow-hidden" ref="funddropdown" toggle-class="py-3">
          <template v-slot:button-content >
            <feather type="filter"></feather>
          </template>
          <b-dropdown-form class="px-3" style="width: calc(100vw - 1.25rem);">
            <h6 class="mt-2">Show Last</h6>
            <b-row>
              <b-col>
                <b-form-radio v-model="search.records" name="records" value="10">10 Records</b-form-radio>
              </b-col>
              <b-col>
                <b-form-radio v-model="search.records" name="records" value="25">25 Records</b-form-radio>
              </b-col>
              <div class="w-100"></div>
              <b-col>
                <b-form-radio v-model="search.records" name="records" value="50">50 Records</b-form-radio>
              </b-col>
              <b-col>
                <b-form-radio v-model="search.records" name="records" value="100">100 Records</b-form-radio>
              </b-col>
            </b-row>
            <h6 class="mt-2">Date Period</h6>
            <b-row>
              <b-col>
                <b-form-radio v-model="search.period" name="period" value="today">Today</b-form-radio>
              </b-col>
              <b-col>
                <b-form-radio v-model="search.period" name="period" value="yesterday">Yesterday</b-form-radio>
              </b-col>
              <div class="w-100"></div>
              <b-col>
                <b-form-radio v-model="search.period" name="period" value="thisweek">This Week</b-form-radio>
              </b-col>
              <b-col>
                <b-form-radio v-model="search.period" name="period" value="lastweek">Last Week</b-form-radio>
              </b-col>
              <div class="w-100"></div>
              <b-col>
                <b-form-radio v-model="search.period" name="period" value="thismonth">This Month</b-form-radio>
              </b-col>
              <b-col>
                <b-form-radio v-model="search.period" name="period" value="lastmonth">Last Month</b-form-radio>
              </b-col>
              <div class="w-100"></div>
              <b-col>
                <b-form-radio v-model="search.period" name="period" value="custom">Custom</b-form-radio>
              </b-col>
              <div class="w-100"></div>
              <b-col>
                <datepicker class="search-bar" :disabled="search.period !== 'custom'" placeholder="Date From" :bootstrap-styling="true" input-class="form-control-sm" v-model="search.dateFrom" :format="'d MMM, yyyy'"></datepicker>
              </b-col>
              <b-col>
                <datepicker class="search-bar" :disabled="search.period !== 'custom'" placeholder="Date To" :bootstrap-styling="true" input-class="form-control-sm" v-model="search.dateTo" :format="'d MMM, yyyy'" :disabled-dates="disabledDates" :key="dpKey"></datepicker>
              </b-col>
            </b-row>
            <h6 class="mt-2">Payment Type</h6>
            <b-row>
              <b-col>
                <b-form-checkbox v-model="search.types.debit">Debit</b-form-checkbox>
              </b-col>
              <b-col>
                <b-form-checkbox v-model="search.types.credit">Credit</b-form-checkbox>
              </b-col>
            </b-row>
            <h6 class="mt-2">Currency</h6>
            <b-row>
              <b-col>
                <b-form-checkbox-group stacked v-model="search.currencies">
                  <b-form-checkbox name="currency" :value="currency.id" v-for="currency in availableCurrencies" :key="currency.id">
                    <div class="flag mr-2" :class="'flag-' + currency.flag"></div>
                    <strong>{{ currency.value }}</strong>
                    {{ currency.name }}
                  </b-form-checkbox>
                </b-form-checkbox-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col offset="6">
                <b-button class="my-2" size="sm" pill block variant="outline-primary" href="#" @click.prevent="$refs.funddropdown.hide(true)">Close</b-button>
              </b-col>
            </b-row>
          </b-dropdown-form>
        </b-dropdown>
        <b-dropdown ref="dropdown" no-caret right variant="link" class="float-right" menu-class="box-shadow border-0 vw-85 rounded-sm" toggle-class="py-3">
          <template v-slot:button-content>
            <feather class="color-white" type="search"></feather>
          </template>
          <b-dropdown-form class="p-3">
            <b-input-group>
              <b-form-input id="search" placeholder="Search Statement" v-model="search.term"></b-form-input>
              <b-input-group-append>
                <div class="input-group-text bg-transparent border-left-0">
                  <feather type="search"></feather>
                </div>
              </b-input-group-append>
            </b-input-group>
          </b-dropdown-form>
        </b-dropdown>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { mapState } from 'vuex'

function addDays (date, days) {
  var result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

export default {
  props: {
    search: Object
  },
  components: {
    Datepicker
  },
  data () {
    return {
      disabledDates: {
        customPredictor: this.isDateDisabled
      },
      dpKey: 0
    }
  },
  computed: {
    ...mapState({
      auth: (state) => state.auth,
      company: (state) => state.company,
      currency: (state) => state.currency,
      userStore: (state) => state.user
    }),
    availableCurrencies () {
      const _currencies = []
      this.currency.currencies.forEach((_currency) => {
        if (_currency.id === 'ZAR') {
          _currencies.push(_currency)
        } else {
          if (this.auth && this.auth.user && this.auth.user.user && this.user) {
            if (this.auth.user.user.company) {
              if (this.company.company) {
                const _funds = this.company.company.funds.foreign.find(
                  (fund) => fund.currency === _currency.id
                )
                if (_funds) {
                  _currencies.push(_currency)
                }
              }
            } else {
              const _funds = this.user.funds.foreign.find(
                (fund) => fund.currency === _currency.id
              )
              if (_funds) {
                _currencies.push(_currency)
              }
            }
          }
        }
      })

      return _currencies
    },
    user () {
      return this.userStore ? this.userStore.user : null
    }
  },
  methods: {
    isDateDisabled: function (date) {
      if (date < this.search.dateFrom) {
        return true
      } else if (date > addDays(this.search.dateFrom, 31)) {
        return true
      }
    }
  }
}
</script>
